<template>
<div class="chapter">
<div class="inner_page">
<p class="paraNoIndent2">Note: The poster images can be enlarged for better visibility on most ereader devices. Please consult your user manual for instructions.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02b_note.vue?803ed310